import React, { useState } from "react";
import { Link } from "react-router-dom";
import { navBarItems } from "../../utils/navBarItems";
import Close from "../../svgs/topbar/Close";
import Bg from "../../svgs/topbar/Bg";
import Hamburger from "../../svgs/topbar/Hamburger";
import { useLocation } from 'react-router-dom';

export default function Topbar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="w-full flex justify-center bg-transparent h-28 ">
      <div className="w-full flex relative m-6 lg:hidden ">
        {isOpen && (
          <>
            <div onClick={() => setIsOpen(!isOpen)} className="cursor-pointer ">
              <Close />
            </div>
            <div className="relative ml-2 w-[134px] h-[119px]">
              <div
                className={`z-10 font-bold  absolute uppercase text-sm
              top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-center
              `}
              >
                {navBarItems.map((item) => (
                  <Link
                    key={item.id}
                    to={item.link}
                    className={`${item.id === 3 && "hidden"}`}
                  >
                    <div className="my-1">
                      <span className={`${location.pathname === item.link ? "text-white" : "text-[#80FF00]"} cursor-pointer`}>{item.name}</span>
                    </div>
                  </Link>
                ))}
              </div>
              <div className="absolute top-0">
                <Bg />
              </div>
            </div>
          </>
        )}
        {!isOpen && (
          <div onClick={() => setIsOpen(!isOpen)} className="cursor-pointer ">
            <Hamburger />
          </div>
        )}
      </div>
      <div className="w-10/12 hidden lg:flex justify-between items-center text-center">
        {navBarItems.map((item) =>
          item.name !== "Logo" ? (
            <Link key={item.id} to={item.link} className="w-1/5">
              <div>
                <span className="font-Red-Undead text-lg text-primary-green">
                  {item.name}
                </span>
              </div>
            </Link>
          ) : (
            <Link key={item.id} to="/" className="w-1/5">
              <div className="logo items-center">
                <img src={item.logo} alt={"purge-token"} className="mx-auto" />
              </div>
            </Link>
          )
        )}
      </div>
    </div>
  );
}
